import { render, staticRenderFns } from "./RepairKit.vue?vue&type=template&id=1372b632&scoped=true&"
import script from "./RepairKit.vue?vue&type=script&lang=js&"
export * from "./RepairKit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1372b632",
  null
  
)

export default component.exports